import Agent from '../../../../common/agent';

const ENGAGE_LANGUAGES = require('../../../../shared/engage/engage-languages')().engageLanguages();

/**
 * Provides data necessary to handle permalink
 * @param {*} isDemoAccount
 * @param {*} project
 * @returns {
 *   queryParams: string, // e.g. '?isPreview=true&lang=en'
 *   language: object, // e.g. { languageCode: 'en', languageName: 'English' }
 *   hasMultipleLanguages: boolean // true if the project has more than one language
 * }
 */
export default function getPermalinkData(isDemoAccount, project) {
  const _queryParams = [];

  // handling preview mode for demo accounts
  if (isDemoAccount) {
    _queryParams.push('isPreview=true');
  }

  // handling language for permalink
  const languages = project?.languages || [];
  const hasMultipleLanguages = languages.length > 1;

  const selectedLanguageCode = Agent.getLanguage();
  const language = ENGAGE_LANGUAGES.find((lng) => lng.languageCode === selectedLanguageCode);

  // add language query parameter if the project has multiple languages
  if (hasMultipleLanguages) {
    _queryParams.push(`lang=${selectedLanguageCode}`);
  }

  // concatenate query parameters for language and preview mode (if any)
  const queryParams = _queryParams.length > 0 ? `?${_queryParams.join('&')}` : '';

  const res = {
    queryParams,
    language,
    hasMultipleLanguages,
  };

  return res;
}
